import { TextSmall } from '@/components/Texts';

const basisList = [
  '- Art. 6 (1) p. 1 lit. a GDPR ("consent"): Where the data subject has voluntarily, in an informed manner and unambiguously indicated by a statement or other unambiguous affirmative act that he or she consents to the processing of personal data relating to him or her for one or more specific purposes;',
  '- Art. 6 para. 1 p. 1 lit. b GDPR: If the processing is necessary for the performance of a contract to which the data subject is a party or for the performance of pre-contractual measures taken at the request of the data subject;',
  '- Art. 6 para. 1 p. 1 lit. c GDPR: If the processing is necessary for compliance with a legal obligation to which the controller is subject (e.g. a legal obligation to keep records);',
  '- Art. 6 para. 1 p. 1 lit. d GDPR: If the processing is necessary to protect the vital interests of the data subject or another natural person;',
  '- Art. 6 (1) p. 1 lit. e GDPR: Where processing is necessary for the performance of a task carried out in the public interest or in the exercise of official authority vested in the controller, or',
  '- Art. 6 (1) p. 1 lit. f GDPR ("Legitimate Interests"): When processing is necessary to protect the legitimate (in particular legal or economic) interests of the controller or a third party, unless the conflicting interests or rights of the data subject override (in particular if the data subject is a minor).',
];

const LegalBasisDataProcessing = () => {
  return (
    <>
      <TextSmall fontWeight={700}>
        (4) Legal basis for data processing
      </TextSmall>
      <TextSmall>
        By law, in principle, any processing of personal data is prohibited and
        only permitted if the data processing falls under one of the following
        justifications:
      </TextSmall>
      {basisList.map((item, index) => {
        return (
          <TextSmall pl={8} key={index + 'basis'}>
            {item}
          </TextSmall>
        );
      })}

      <TextSmall>
        For the processing operations carried out by us, we indicate below the
        applicable legal basis in each case. A processing operation may also be
        based on several legal bases.
      </TextSmall>
    </>
  );
};

export default LegalBasisDataProcessing;
